import * as SG from '../style/Styles'
import * as TXT from './../util/Texts'

const alignSubTitle = 'left'

export default function InfosRegulation() {

  return (
    <>
    <SG.Title style={{textAlign:'center'}} className='upperCase'>{TXT.REGULAMENT}</SG.Title>
    <SG.BoxGrey className='boxRelugament'>
      <SG.PADD style={{paddingLeft:30, paddingRight:30}}>

          <SG.TitleDarkBlue style={{textAlign:`${alignSubTitle}`}}>{TXT.REG_TITLE_1}</SG.TitleDarkBlue>
          <SG.InfosRegulament>{TXT.REG_TEXT_1_2}</SG.InfosRegulament>
          <SG.InfosRegulament>{TXT.REG_TEXT_1_3}</SG.InfosRegulament>
          <SG.InfosRegulament>{TXT.REG_TEXT_1_4}</SG.InfosRegulament>

          <SG.HR />

          <SG.TitleDarkBlue style={{textAlign:`${alignSubTitle}`}}>{TXT.REG_TITLE_2}</SG.TitleDarkBlue>
          <SG.InfosRegulament>{TXT.REG_TEXT_2_1}</SG.InfosRegulament>
          <SG.InfosRegulament>{TXT.REG_TEXT_2_2}</SG.InfosRegulament>
          <SG.InfosRegulament>{TXT.REG_TEXT_2_3}</SG.InfosRegulament>
          <SG.InfosRegulament>{TXT.REG_TEXT_2_4}</SG.InfosRegulament>
          <SG.InfosRegulament>{TXT.REG_TEXT_2_5}</SG.InfosRegulament>
          <SG.SubSubTitleDark style={{textAlign:`${alignSubTitle}`}}>{TXT.REG_SUB_WINNER}</SG.SubSubTitleDark>

          <ul>
            <SG.LiRegulament>{TXT.REG_LI_WINNER_1}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_WINNER_2}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_WINNER_3}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_WINNER_4}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_WINNER_5}</SG.LiRegulament>
          </ul>

          <SG.SubSubTitleDark style={{textAlign:`${alignSubTitle}`}}>{TXT.REG_SUB_DRAW}</SG.SubSubTitleDark>

          <ul>
            <SG.LiRegulament>{TXT.REG_LI_DRAW_1}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_DRAW_2}</SG.LiRegulament>
          </ul>

          <SG.InfosRegulament>{TXT.REG_TEXT_MULTIPLIER}</SG.InfosRegulament>

          <SG.HR />

          <SG.TitleDarkBlue style={{textAlign:`${alignSubTitle}`}}>{TXT.REG_TITLE_3}</SG.TitleDarkBlue>
          <SG.InfosRegulament>{TXT.REG_TEXT_3_1}</SG.InfosRegulament>

          <ul>
            <SG.LiRegulament>{TXT.REG_LI_TIE_1}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_TIE_2}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_TIE_3}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_TIE_4}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_TIE_5}</SG.LiRegulament>
          </ul>

          <SG.HR />

          <SG.TitleDarkBlue style={{textAlign:`${alignSubTitle}`}}>{TXT.REG_TITLE_4}</SG.TitleDarkBlue>

          <SG.InfosRegulament>{TXT.REG_TEXT_4_1}</SG.InfosRegulament>
          <SG.InfosRegulament>{TXT.REG_TEXT_4_2}</SG.InfosRegulament>

          <ul>
            <SG.LiRegulament>{TXT.REG_LI_RANK_1}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_RANK_2}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_RANK_3}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_RANK_4}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_RANK_5}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_RANK_6}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_RANK_7}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_RANK_8}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_RANK_9}</SG.LiRegulament>
          </ul>

          <SG.InfosRegulament>{TXT.REG_TEXT_4_3}</SG.InfosRegulament>
          <SG.InfosRegulament>{TXT.REG_TEXT_4_4}</SG.InfosRegulament>
{/* 
          <SG.HR />

          <SG.TitleDarkBlue style={{textAlign:`${alignSubTitle}`}}>{TXT.REG_TITLE_5}</SG.TitleDarkBlue>
          <SG.InfosRegulament>{TXT.REG_TEXT_5_1}</SG.InfosRegulament>
          <ul>
            <SG.LiRegulament>{TXT.REG_LI_AWARD_10}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_AWARD_9}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_AWARD_8}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_AWARD_7}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_AWARD_6}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_AWARD_5}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_AWARD_4}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_AWARD_3}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_AWARD_2}</SG.LiRegulament>
            <SG.LiRegulament>{TXT.REG_LI_AWARD_1}</SG.LiRegulament>
          </ul> */}

      </SG.PADD>
    </SG.BoxGrey>
    </>
  );
}